import React, { Component } from "react";
import { connect } from "react-redux";
import { addPositionNewOrder } from "../../action/neworder";
import { isEmpty } from "lodash";


class Goods extends Component {
    render() {
        return(
            <div className="neworder_good_button_container">
                {
                    this.props.loaderList
                        ? null
                        : this.props.goods.map((item, index) => ({ ...item, index })).filter((item) => item.isGroup || !item.isGrouped).map((item) => {
                            const isStop = !this.props.neworders.point || (this.props.neworders.point && (this.props.neworders.point.stopList ? this.props.neworders.point.stopList : []).some((el) => parseInt(el.value) === parseInt(item.id)))
                            return (
                                <button 
                                    key={item.groupId || item.id} 
                                    className={`neworder_good_button${item.category.id === this.props.settings.pizza ? ' pizza' : ''}${(!this.props.neworders.point || isStop) ? ' unactived' : ''}`} 
                                    onClick={(() => {
                                        if (!isStop) {
                                            this.props.addPositionNewOrder({...item, price: !this.props.neworders.isAggPrice ? item.price : item.oldPrice || item.price}, this.props.settings);

                                            if(window.innerWidth < 930 && window.innerWidth > 640)
                                                this.props.setActiveTabMobile('positionList');
                                        }                                
                                    })}
                                    >
                                        {item.hot && <div className="good_hot_circle"></div>}
                                        {item.vegan && <div className="good_vegan_circle"></div>}
                                        <span className={`neworder_good_button_text${item.category.id === this.props.settings.pizza ? ' pizza' : ''}`}> {item.name} </span>
                                        {!this.props.neworders.isAggPrice 
                                        ?
                                        <span className="neworder_good_button_text price"> {`${item.price} ₽`} </span>
                                        :
                                        <span className="neworder_good_button_text price"> {`${item.oldPrice} ₽`} </span>
                                        }
                                        {!isEmpty(item.modifications.filter((mod) => !!mod.active)) && !item.isGroup && item.category.id === this.props.settings.pizza && 
                                        <div className="neworder_pizza_modification_button_div">
                                            <button 
                                                className={`neworder_pizza_modification_button ${!item.isMod ? 'actived' : ''}`} 
                                                onClick={((event) => {
                                                    event.stopPropagation();
                                                    if (!item.isMod) return null;
                                                    this.props.changeModification(item.id, item.modifications.find((mod) => mod.default))
                                                })}
                                                > 
                                                30см
                                            </button>
                                            <button 
                                                className={`neworder_pizza_modification_button ${item.isMod ? 'actived' : ''}`} 
                                                onClick={((event) => {
                                                    event.stopPropagation();
                                                    if (item.isMod) return null;
                                                    this.props.changeModification(item.id, item.modifications.find((mod) => !mod.default))
                                                })}
                                                > 
                                                36см
                                            </button>
                                        </div>
                                        }
                                        {item.isGroup && item.items && item.items.length > 1 && 
                                        <div className="neworder_pizza_modification_button_div">
                                            {
                                                item.items.sort((a, b) => (b.order || 0) - (a.order || 0)).map((option) => {
                                                    return (
                                                        <button 
                                                            className={`neworder_pizza_modification_button ${item.id === option.id ? 'actived' : ''}`} 
                                                            onClick={((event) => {
                                                                event.stopPropagation();
                                                                this.props.changeOptionGroup(item.index, option.id);
                                                            })}
                                                            > 
                                                            {option.groupTitle || option.name || ''}
                                                        </button>
                                                    )
                                                })
                                            }
                                        </div>
                                        }
                                </button>
                            )
                        })
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    neworders: state.neworders,
    settings: state.settings.init.categories
});

const mapDispatchToProps = {
    addPositionNewOrder: (good, settings) => addPositionNewOrder(good, settings)
}

export default connect(mapStateToProps, mapDispatchToProps)(Goods);